<template>
	<div id="app" class="app">
		<main-navigation />
		<page-body
			v-if="!$store.state.contentNotFound && !$store.state.apiError"
		/>
		<not-found
			v-if="$store.state.contentNotFound"
		/>
		<api-error
			v-if="$store.state.apiError"
		/>
		<page-footer
			v-if="$route.name !== $GLOBALS.ROUTE_SHARED"
		/>
		<popup
			v-if="$store.state.popupOpen"
		/>
		<choose-topic-modal />
		<saved-info-modal />
		<search
			v-if="$store.state.searchOpen"
		/>
		<cookie-popup
			v-if="$store.state.analyticsCookies === null && $route.path !== '/privacy-policy'"
		/>
	</div>
</template>

<script>
// Styles
import '@/sass/style.scss';

// Components
import PageBody from '@/components/layout/PageBody.vue';
import PageFooter from '@/components/layout/PageFooter.vue';
import MainNavigation from '@/components/modals/MainNavigationModal.vue';
import Popup from '@/components/global/Popup.vue';
import ChooseTopicModal from '@/components/modals/ChooseTopicModal.vue';
import SavedInfoModal from '@/components/modals/SavedInfoModal.vue';
import Search from '@/components/global/Search.vue';
import NotFound from '@/components/blocks/NotFound.vue';
import ApiError from '@/components/blocks/ApiError.vue';
import CookiePopup from '@/components/global/CookiePopup.vue';

export default {
	components: {
		PageBody,
		PageFooter,
		MainNavigation,
		Popup,
		ChooseTopicModal,
		SavedInfoModal,
		Search,
		NotFound,
		ApiError,
		CookiePopup
	},
	methods: {
		getRecipientTypes() {
			this.$store.commit('contentLoading', true);
			this.$recipientTypes
				.get({
					include: 'featuredImage'
				})
				.then(response => {
					this.$store.commit('setRecipientTypes', response.getData().data);
					this.$store.commit('contentLoading', false);
				})
				.catch(() => {
					this.$store.commit('contentLoading', false);
					this.$store.commit('apiError', true);
				});
		},
		getTopics() {
			this.$store.commit('contentLoading', true);
			this.$topics
				.get({
					include: 'featuredImage'
				})
				.then(response => {
					this.$store.commit('setTopics', response.getData().data);
					this.$store.commit('contentLoading', false);
				})
				.catch(() => {
					this.$store.commit('contentLoading', false);
					this.$store.commit('apiError', true);
				});
		},
		getSave() {
			let saveId = sessionStorage.getItem('save');
			let savedContent = [];

			if (saveId) {
				this.$store.commit('contentLoading', true);
				this.$saves
					.single(saveId, {
						include: 'content'
					})
					.then(response => {
						const data = response.getData().data;

						data.content.forEach(function(content) {
							savedContent.push(content.id);
						});

						this.$store.commit('setSave', data);
						this.$store.commit('addSavedContent', savedContent);

						this.$store.commit('contentLoading', false);
					})
					.catch(() => {
						this.$store.commit('contentLoading', false);
						this.$store.commit('apiError', true);
					});
			}
		},
		getSelectedRecipients() {
			let data = JSON.parse(sessionStorage.getItem('selectedRecipients'));

			if (data) {
				this.$store.commit('selectedRecipients', data);
			}
		},
		getAnalyticsCookies() {
			let data = localStorage.getItem('analytics-cookies');
			const $this = this;

			if (data && data === 'on') {
				this.$store.commit('setAnalyticsCookies', true);
			} else if (data && data === 'off') {
				this.$store.commit('setAnalyticsCookies', false);
			} else if (data === null) {
				setTimeout(function() {
					$this.$store.commit('setAnalyticsCookies', null)
				}, 2000);
			} else if (data === 'null') {
				$this.$store.commit('setAnalyticsCookies', null);
			}
		}
	},
	created() {
		this.getAnalyticsCookies();
		this.getRecipientTypes();
		this.getTopics();
		this.getSave();
		this.getSelectedRecipients();
	}
};
</script>
